import { deprecated } from 'typesafe-actions'

import {
  Creative,
  CreativeAction,
  CreativeId,
} from '../../interfaces/entities/creative'
import { Comment } from '../../interfaces/entities/comment'
import { Result, IAppError } from '../../interfaces/base'

const { createAction } = deprecated

export const getCreative = createAction(
  'creative_details/GET_CREATIVE',
  (resolve) => {
    return (creativeId: string) => resolve(creativeId)
  },
)

export const getCreativeComplete = createAction(
  'creative_details/GET_CREATIVE_COMPLETE',
  (resolve) => {
    return (response: Result<Creative, IAppError>) => resolve(response)
  },
)

export const makeCreative = createAction('creative_details/MAKE_CREATIVE')

export const makeCreativeComplete = createAction(
  'creative_details/MAKE_CREATIVE_COMPLETE',
)

export const doCreativeAction = createAction(
  'creative_details/DO_CREATIVE_ACTION',
  (resolve) => {
    return (creative: Creative, action: CreativeAction) =>
      resolve({ creative, action })
  },
)

export const doCreativeActionComplete = createAction(
  'creative_details/DO_CREATIVE_ACTION_COMPLETE',
  (resolve) => {
    return (
      response: Result<
        { action: CreativeAction; creative: Creative; message: string },
        IAppError
      >,
    ) => resolve(response)
  },
)

export const setCreativeComment = createAction(
  'creative/SET_CREATIVE_COMMENT',
  (resolve) => {
    return (creativeId: CreativeId, comment: string) =>
      resolve({ creativeId, comment })
  },
)

export const setCreativeCommentComplete = createAction(
  'creative/SET_CREATIVE_COMMENT_COMPLETE',
  (resolve) => {
    return (response: Result<Comment, IAppError>) => resolve(response)
  },
)

export const leaveCreativePage = createAction('creative/LEAVE_CREATIVE_PAGE')
